import { FaTimes } from "react-icons/fa";

const AddEmployeeModal = ({
  formData,
  handleInputChange,
  handleSubmit,
  setShowAddForm,
  loading,
  error,
}) => {
  return (
    <div className="modal-overlay">
      <div className="add-modal">
        <div className="modal-header">
          <h3>Tambah Karyawan</h3>
          <button className="close-btn" onClick={() => setShowAddForm(false)}>
            <FaTimes />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Nama Lengkap</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleInputChange}
              required
              minLength="6"
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <button type="submit" className="submit-btn" disabled={loading}>
            {loading ? "Memproses..." : "Tambahkan"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddEmployeeModal;
